const ProductsList = () => import('Views/products/products-list-new-ui');

export default[
  { path: '/products-list', component: ProductsList },
];



// WEBPACK FOOTER //
// ./src/router/products.js